import { Skeleton, Tooltip } from '@heroui/react';

import { CopyableText } from '~/components/CopyableText';
import { useTruncatedTooltip } from '~/components/TruncatedText';

type AgentNameCellProps = {
  agentName: string;
};

export function AgentNameCell({ agentName }: AgentNameCellProps) {
  const { ref, isTruncated } = useTruncatedTooltip(agentName);

  if (!agentName) return <span>-</span>;

  return (
    <CopyableText
      text={agentName}
      className='whitespace-normal text-left'
      data-testid='monitor-agent-logs-cell-agent-name'
    >
      <Tooltip isDisabled={!isTruncated} content={agentName}>
        <span
          ref={ref as React.RefObject<HTMLSpanElement>}
          className='line-clamp-1 break-all text-title-sm'
        >
          {agentName}
        </span>
      </Tooltip>
    </CopyableText>
  );
}

export function AgentNameCellSkeleton() {
  return <Skeleton className='h-5 w-[120px] rounded' />;
}
